module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tud-drawer'), _vm._v(" "), _c('tud-toolbar'), _vm._v(" "), _c('main', [_c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    key: _vm.$route.fullPath,
    attrs: {
      "column": "",
      "align-center": "",
      "child-flex": ""
    }
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('tud-snack', {
    attrs: {
      "messages": _vm.messages,
      "visible": _vm.visibleMessages
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cb2576e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
// module id = 604
// module chunks = 12